(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxCreateOnDeviceConfig(
    OnDeviceConfigService, toastr, $filter, RegexModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        printer: '=printer',
        currentOnDeviceConfig: '=currentOnDeviceConfig',
        meta: '=meta',
        callback: '&callback',
        updateParent: '&updateParent'
      },
      templateUrl: 'app/components/onDeviceConfigProperties/createOnDeviceConfig/createOnDeviceConfig.template.html',
      link: function(scope) {

        let regex = new RegexModel();

        scope.onDeviceConfig = {
          name: scope.meta.action === 'UPDATE' ? angular.copy(scope.currentOnDeviceConfig.info.name) : '',
          description: scope.meta.action === 'UPDATE' ? angular.copy(scope.currentOnDeviceConfig.info.description) : '',
          signin: scope.meta.action === 'UPDATE' ? angular.copy(scope.currentOnDeviceConfig.info.signin) : 'AUTO',
          accessCopy: scope.meta.action === 'UPDATE' ? angular.copy(scope.currentOnDeviceConfig.info.accessCopy) : false,
          accessScan: scope.meta.action === 'UPDATE' ? angular.copy(scope.currentOnDeviceConfig.info.accessScan) : false,
          accessEmail: scope.meta.action === 'UPDATE' ? angular.copy(scope.currentOnDeviceConfig.info.accessEmail) : false,
          accessFax: scope.meta.action === 'UPDATE' ? angular.copy(scope.currentOnDeviceConfig.info.accessFax) : false,
          accessUsbPrint: scope.meta.action === 'UPDATE' ? angular.copy(scope.currentOnDeviceConfig.info.accessUsbPrint) : false,
          accessUsbScan: scope.meta.action === 'UPDATE' ? angular.copy(scope.currentOnDeviceConfig.info.accessUsbScan) : false,
          accessEverythingElse: scope.meta.action === 'UPDATE' ? angular.copy(scope.currentOnDeviceConfig.info.accessEverythingElse) : false,
          emailSender: scope.meta.action === 'UPDATE' ? angular.copy(scope.currentOnDeviceConfig.info.emailSender) : null,
          installCaptureApp: scope.meta.action === 'UPDATE' ? angular.copy(scope.currentOnDeviceConfig.info.installCaptureApp) : false,
        };

        scope.FAKE_GO_PRINT_APP = {FAKE: true}

        scope.useOnPrinter = {
          printer: scope.printer ? true : false
        };

        scope.saveOnDeviceConfig = function () {
          switch (scope.meta.action) {
            case 'CREATE' :
              createOnDeviceConfig();
            break;
            case 'UPDATE' :
              updateOnDeviceConfig();
            break;
          }
        }

        scope.testEmail = function () {
          if (scope.onDeviceConfig.emailSender && regex.emailRegex().test(scope.onDeviceConfig.emailSender)) {
            scope.emailValid = true;
          } else {
            scope.emailValid = false;
          }
        }
        scope.testEmail()

        function createOnDeviceConfig () {
          scope.onDeviceConfig.emailSender = scope.onDeviceConfig.emailSender ? scope.onDeviceConfig.emailSender : null
          OnDeviceConfigService.createOnDeviceConfig(scope.onDeviceConfig).then(function(deviceConfig) {
            if (scope.useOnPrinter.printer) {
              scope.printer.assignOnDeviceConfig(deviceConfig.data._links.self.href).then(function(response) {
                toastr.success(scope.printer.info.name)
              }).catch(function(error) {
                toastr.error(scope.printer.info.name)
              });
            }
            toastr.success($filter('translate')('ChangesSaved'))
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'))
          });
          scope.callback();
        }

        function updateOnDeviceConfig () {
          scope.currentOnDeviceConfig.updateOnDeviceConfig(scope.onDeviceConfig).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'));
            scope.updateParent();
          }).catch(function(error) {
            toastr.error($filter('translate')('NoChangesMade'));
          });
          scope.callback();
        }

        scope.$on('$destroy', function() {
        });

      }
    };
  }

  pxCreateOnDeviceConfig.$inject = ['OnDeviceConfigService', 'toastr', '$filter', 'RegexModel'];

  angular
    .module('printix-admin')
    .directive('pxCreateOnDeviceConfig', pxCreateOnDeviceConfig);

})();
